import script from "./multi-selector-picker.vue?vue&type=script&lang=ts&setup=true"
export * from "./multi-selector-picker.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__